import { render, staticRenderFns } from "./VLoading.vue?vue&type=template&id=bc458022"
import script from "./VLoading.vue?vue&type=script&lang=js"
export * from "./VLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports